/**
 * @class  WarningError for errors which is not notifiable and also must
 * be showed in console using warn
 */
export class WarningError extends Error {
  constructor(message: string) {
    super(message);
  }
}
